export default __webpack_public_path__ + "0088722ef90f017b9b5cc315f0ac4ac7.svg";